import type { ClientPrintAction } from '@nest/domain-printers-backend';
import { Command, usePrintActionHandler } from '@nest/internal-frontend';
import { PrinterIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useTerminalClient } from '../../../client-rpc-router';

export const useCommandOutboundDeliveryOrderPrintDocument = ({ id }: { id?: number }): Command => {
	const client = useTerminalClient();

	const printHandler = usePrintActionHandler(
		'outboundDocumentPrintInvoicesByShipmentRoute',
		async (numberOfCopies, printerIds) => {
			if (id) {
				await client.outboundDeliveryOrders.printOutboundDocumentByOutboundDeliveryOrderIdQuery.execute({
					outboundDeliveryOrderId: id,
					numberOfCopies,
					printerIds
				});
			}
		},
		{ allowedActions: ['print'] as ClientPrintAction[] }
	);

	return {
		id: 'print-document',
		label: 'Tisk dokladu',
		icon: <PrinterIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !id,
		loading: printHandler.isLoading,
		run: async () => {
			const ok = await printHandler.run(undefined as never);

			if (ok) {
				toast.success('Doklad byl odeslán na tisk.');
			}
		}
	};
};





